import { call, put } from 'redux-saga/effects';
import moment from 'moment';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { signPDFSuccessful, signPDFFailed, uploadSignFile } from '../actions';
import processError from '../../../utils/processError';
import { BACKEND_URL_V2 } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import sign from './sign';
import { nameBySave } from '../../../utils/utils';
import { dateFormatter } from '../../../utils/formatters';

export default function* signPDF(action) {
  try {
    const { cert, document, file } = action.payload;
    const headers = {
      // Accept: 'multipart/form-data',
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };
    const pool = new FormData();
    pool.append('signature_signer', cert.cn);
    pool.append('signature_cast', cert.thumbprint);
    pool.append('certificate_start_date', moment(cert.certFromDate).format('YYYY-MM-DD'));
    pool.append('certificate_end_date', moment(cert.certToDate).format('YYYY-MM-DD'));
    pool.append('file', file[0], file[0]?.name || '');

    const url = `${BACKEND_URL_V2}/documents/generate-pdf-with-sign-stamp`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true, headers, true);
    if (dataResponse.status !== OK) {
      const error = yield dataResponse.json();
      throw new Error(error?.message || 'Ошибка: не найден файл для подписи');
    }

    const data = yield dataResponse.blob();

    if (!data) {
      const error = yield dataResponse.json();
      throw new Error(error?.message || 'Ошибка: не найден файл для подписи');
    }
    const signature = yield sign(cert, data, true);
    if (typeof signature === 'string') {
      throw new Error(signature);
    }
    const fileFormData = new FormData();
    const templateName = document && document.notification_template && document.notification_template.name
      ? document.notification_template.name
      : document.id;
    const name = nameBySave(`${templateName} № ${document.number} от ${dateFormatter(document.created_at)}.pdf`);

    fileFormData.append('model_type', 'document');
    fileFormData.append('model_id', document.id);
    fileFormData.append('collection_name', 'signed');
    fileFormData.append('name', name);
    fileFormData.append('file', data, nameBySave(name));
    fileFormData.append('sign_file', signature, nameBySave(`${name}.sig`));
    const fileUploadPromise = yield put(uploadSignFile(fileFormData));
    const fileUpload = yield fileUploadPromise;
    //
    // const signatureUploadPromise = yield put(uploadFile(sigFormData));
    // const signatureUpload = yield signatureUploadPromise;
    if (!fileUpload) {
      throw new Error(`Фаил «${name}.sig» не сохранен`);
    }

    if (typeof signature !== 'string') {
      yield put(signPDFSuccessful(signature));
      yield call(resolveActionPromise(action, signature));
      return signature;
    }
    yield put(signPDFFailed(false));
    yield call(rejectActionPromise(action, false));
    return false;
  } catch (e) {
    yield put(signPDFFailed(false));
    yield call(rejectActionPromise(action, e && e.message ? e.message : ''));
    yield processError(e);
    return false;
  }
}
